export default [
  {
    params: {
      name: 'components/AlertsView',
      path: '/components/alerts',
    },
    defaultComponentPath: 'Vuetify/AlertsView',
    navs: true,
  },
  {
    params: {
      name: 'components/AvatarsView',
      path: '/components/avatars',
    },
    defaultComponentPath: 'Vuetify/AvatarsView',
    navs: true,
  },
  {
    params: {
      name: 'components/BadgeView',
      path: '/components/badge',
    },
    defaultComponentPath: 'Vuetify/BadgeView',
    navs: true,
  },
  {
    params: {
      name: 'components/BannersView',
      path: '/components/banners',
    },
    defaultComponentPath: 'Vuetify/BannersView',
    navs: true,
  },
  {
    params: {
      name: 'components/AppBarsView',
      path: '/components/bars/app-bars',
    },
    defaultComponentPath: 'Vuetify/Bars/AppBars',
    navs: true,
  },
  {
    params: {
      name: 'components/ToolbarView',
      path: '/components/bars/toolbar',
    },
    defaultComponentPath: 'Vuetify/Bars/Toolbar',
    navs: true,
  },
  {
    params: {
      name: 'components/SystemBarsView',
      path: '/components/bars/system-bar',
    },
    defaultComponentPath: 'Vuetify/Bars/SystemBars',
    navs: true,
  },
  {
    params: {
      name: 'components/BottomNavigationView',
      path: '/components/bottom-navigation',
    },
    defaultComponentPath: 'Vuetify/BottomNavigation',
    navs: true,
  },
  {
    params: {
      name: 'components/BottomSheetsView',
      path: '/components/bottom-sheets',
    },
    defaultComponentPath: 'Vuetify/BottomSheets',
    navs: true,
  },
  {
    params: {
      name: 'components/Breadcrumbs',
      path: '/components/breadcrumbs',
    },
    defaultComponentPath: 'Vuetify/Breadcrumbs',
    navs: true,
  },
  {
    params: {
      name: 'components/Buttons',
      path: '/components/buttons',
    },
    defaultComponentPath: 'Vuetify/Buttons/Buttons',
    navs: true,
  },
  {
    params: {
      name: 'components/FloatingActionButtons',
      path: '/components/buttons/floating-action-buttons',
    },
    defaultComponentPath: 'Vuetify/Buttons/FloatingActionButtons',
    navs: true,
  },
  {
    params: {
      name: 'components/ButtonGroups',
      path: '/components/buttons/button-groups',
    },
    defaultComponentPath: 'Vuetify/Buttons/ButtonGroups',
    navs: true,
  },
  {
    params: {
      name: 'components/Calendars',
      path: '/components/calendars',
    },
    defaultComponentPath: 'Vuetify/Calendars',
    navs: true,
  },
  {
    params: {
      name: 'components/Cards',
      path: '/components/cards',
    },
    defaultComponentPath: 'Vuetify/Cards',
    navs: true,
  },
  {
    params: {
      name: 'components/Carousels',
      path: '/components/carousels',
    },
    defaultComponentPath: 'Vuetify/Carousels',
    navs: true,
  },
  {
    params: {
      name: 'components/Chips',
      path: '/components/chips',
    },
    defaultComponentPath: 'Vuetify/Chips/Chips',
    navs: true,
  },
  {
    params: {
      name: 'components/ChipGroups',
      path: '/components/chips/chip-groups',
    },
    defaultComponentPath: 'Vuetify/Chips/ChipGroups',
    navs: true,
  },
  {
    params: {
      name: 'components/Dialogs',
      path: '/components/dialogs',
    },
    defaultComponentPath: 'Vuetify/Dialogs',
    navs: true,
  },
  {
    params: {
      name: 'components/DividersView',
      path: '/components/dividers',
    },
    defaultComponentPath: 'Vuetify/DividersView',
    navs: true,
  },
  {
    params: {
      name: 'components/ApiExplorerView',
      path: '/components/vuetify/api-explorer',
    },
    defaultComponentPath: 'Vuetify/ApiExplorerView',
    navs: true,
  },
  {
    params: {
      name: 'ColorsUI',
      path: '/colors',
    },
    defaultComponentPath: 'Vuetify/UI/ColorsUI',
    navs: true,
  },
  {
    params: {
      name: 'IconsView',
      path: '/icons',
    },
    defaultComponentPath: 'Vuetify/UI/Icons',
    navs: true,
  },
  {
    params: {
      name: 'HelpersView',
      path: '/helpers',
    },
    defaultComponentPath: 'Vuetify/UI/Helpers/index',
    navs: true,
  },
  {
    params: {
      name: 'BorderRadius',
      path: '/border-radius',
    },
    defaultComponentPath: 'Vuetify/UI/BorderRadius',
    navs: true,
  },
  {
    params: {
      name: 'TextTypographyView',
      path: '/text-typography',
    },
    defaultComponentPath: 'Vuetify/UI/TextTypography/index',
    navs: true,
  },
  {
    params: {
      name: 'Transitions',
      path: '/transitions',
    },
    defaultComponentPath: 'Vuetify/UI/Transitions',
    navs: true,
  },
  {
    params: {
      name: 'Scroll',
      path: '/scroll',
    },
    defaultComponentPath: 'Vuetify/UI/Scroll',
    navs: true,
  },
  {
    params: {
      name: 'components/ExpansionPanels',
      path: '/components/expansion-panels',
    },
    defaultComponentPath: 'Vuetify/ExpansionPanels',
    navs: true,
  },
  {
    params: {
      name: 'components/Footer',
      path: '/components/footer',
    },
    defaultComponentPath: 'Vuetify/Footer',
    navs: true,
  },
  {
    params: {
      name: 'components/Autocompletes',
      path: '/components/forms-control/autocompletes',
    },
    defaultComponentPath: 'Vuetify/FormControls/Autocompletes',
    navs: true,
  },
  {
    params: {
      name: 'components/Combobox',
      path: '/components/forms-control/combobox',
    },
    defaultComponentPath: 'Vuetify/FormControls/Combobox',
    navs: true,
  },
  {
    params: {
      name: 'components/FileInputs',
      path: '/components/forms-control/file-inputs',
    },
    defaultComponentPath: 'Vuetify/FormControls/FileInputs',
    navs: true,
  },
  {
    params: {
      name: 'components/Forms',
      path: '/components/forms-control/forms',
    },
    defaultComponentPath: 'Vuetify/FormControls/Forms',
    navs: true,
  },
  {
    params: {
      name: 'components/Inputs',
      path: '/components/forms-control/inputs',
    },
    defaultComponentPath: 'Vuetify/FormControls/Inputs',
    navs: true,
  },
  {
    params: {
      name: 'components/OverflowBtns',
      path: '/components/forms-control/overflow-btns',
    },
    defaultComponentPath: 'Vuetify/FormControls/OverflowBtns',
    navs: true,
  },
  {
    params: {
      name: 'components/Selects',
      path: '/components/forms-control/selects',
    },
    defaultComponentPath: 'Vuetify/FormControls/Selects',
    navs: true,
  },
  {
    params: {
      name: 'components/SelectionControls',
      path: '/components/forms-control/selection-controls',
    },
    defaultComponentPath: 'Vuetify/FormControls/SelectionControls',
    navs: true,
  },
  {
    params: {
      name: 'components/Sliders',
      path: '/components/forms-control/sliders',
    },
    defaultComponentPath: 'Vuetify/FormControls/Sliders',
    navs: true,
  },
  {
    params: {
      name: 'components/Textarea',
      path: '/components/forms-control/textarea',
    },
    defaultComponentPath: 'Vuetify/FormControls/Textarea',
    navs: true,
  },
  {
    params: {
      name: 'components/Textfields',
      path: '/components/forms-control/text-fields',
    },
    defaultComponentPath: 'Vuetify/FormControls/Textfields',
    navs: true,
  },
  {
    params: {
      name: 'components/Grids',
      path: '/components/grids',
    },
    defaultComponentPath: 'Vuetify/Grids',
    navs: true,
  },
  {
    params: {
      name: 'components/Hover',
      path: '/components/hover',
    },
    defaultComponentPath: 'Vuetify/Hover',
    navs: true,
  },
  {
    params: {
      name: 'components/Icons',
      path: '/components/icons',
    },
    defaultComponentPath: 'Vuetify/Icons',
    navs: true,
  },
  {
    params: {
      name: 'components/Images',
      path: '/components/images',
    },
    defaultComponentPath: 'Vuetify/Images',
    navs: true,
  },
  {
    params: {
      name: 'components/Lazy',
      path: '/components/lazy',
    },
    defaultComponentPath: 'Vuetify/Lazy',
    navs: true,
  },
  {
    params: {
      name: 'components/Lists',
      path: '/components/lists',
    },
    defaultComponentPath: 'Vuetify/Lists/Lists',
    navs: true,
  },
  {
    params: {
      name: 'components/ItemGroupView',
      path: '/components/lists/item-groups',
    },
    defaultComponentPath: 'Vuetify/Lists/ItemGroupView',
    navs: true,
  },
  {
    params: {
      name: 'components/Menus',
      path: '/components/menus',
    },
    defaultComponentPath: 'Vuetify/Menus',
    navs: true,
  },
  {
    params: {
      name: 'components/NavigationDrawers',
      path: '/components/navigation-drawers',
    },
    defaultComponentPath: 'Vuetify/NavigationDrawers',
    navs: true,
  },
  {
    params: {
      name: 'components/Overlays',
      path: '/components/overlays',
    },
    defaultComponentPath: 'Vuetify/Overlays',
    navs: true,
  },
  {
    params: {
      name: 'components/Paginations',
      path: '/components/paginations',
    },
    defaultComponentPath: 'Vuetify/Paginations',
    navs: true,
  },
  {
    params: {
      name: 'components/Parallax',
      path: '/components/parallax',
    },
    defaultComponentPath: 'Vuetify/Parallax',
    navs: true,
  },
  {
    params: {
      name: 'components/ColorPickers',
      path: '/components/pickers/color-pickers',
    },
    defaultComponentPath: 'Vuetify/Pickers/ColorPickers',
    navs: true,
  },
  {
    params: {
      name: 'components/DatePickers',
      path: '/components/pickers/date-pickers',
    },
    defaultComponentPath: 'Vuetify/Pickers/DatePickers',
    navs: true,
  },
  {
    params: {
      name: 'components/TimePickers',
      path: '/components/pickers/time-pickers',
    },
    defaultComponentPath: 'Vuetify/Pickers/TimePickers',
    navs: true,
  },
  {
    params: {
      name: 'components/CircularProgress',
      path: '/components/progress/progress-circular',
    },
    defaultComponentPath: 'Vuetify/Progress/Circular',
    navs: true,
  },
  {
    params: {
      name: 'components/LinearProgress',
      path: '/components/progress/progress-linear',
    },
    defaultComponentPath: 'Vuetify/Progress/Linear',
    navs: true,
  },
  {
    params: {
      name: 'components/Ratings',
      path: '/components/ratings',
    },
    defaultComponentPath: 'Vuetify/Ratings',
    navs: true,
  },
  {
    params: {
      name: 'components/Sheets',
      path: '/components/sheets',
    },
    defaultComponentPath: 'Vuetify/Sheets',
    navs: true,
  },
  {
    params: {
      name: 'components/SkeletonLoaders',
      path: '/components/skeleton-loaders',
    },
    defaultComponentPath: 'Vuetify/SkeletonLoaders',
    navs: true,
  },
  {
    params: {
      name: 'components/Snackbars',
      path: '/components/snackbars',
    },
    defaultComponentPath: 'Vuetify/Snackbars',
    navs: true,
  },
  {
    params: {
      name: 'components/Steppers',
      path: '/components/steppers',
    },
    defaultComponentPath: 'Vuetify/Steppers',
    navs: true,
  },
  {
    params: {
      name: 'components/Subheaders',
      path: '/components/subheaders',
    },
    defaultComponentPath: 'Vuetify/Subheaders',
    navs: true,
  },
  {
    params: {
      name: 'components/DataIterators',
      path: '/components/tables/data-iterators',
    },
    defaultComponentPath: 'Vuetify/Tables/DataIterators',
    navs: true,
  },
  {
    params: {
      name: 'components/SimpleTables',
      path: '/components/tables/simple-tables',
    },
    defaultComponentPath: 'Vuetify/Tables/SimpleTables',
    navs: true,
  },
  {
    params: {
      name: 'components/DataTables',
      path: '/components/tables/data-tables',
    },
    defaultComponentPath: 'Vuetify/Tables/DataTables',
    navs: true,
  },
  {
    params: {
      name: 'components/Tabs',
      path: '/components/tabs',
    },
    defaultComponentPath: 'Vuetify/Tabs',
    navs: true,
  },
  {
    params: {
      name: 'components/Timelines',
      path: '/components/timelines',
    },
    defaultComponentPath: 'Vuetify/Timelines',
    navs: true,
  },
  {
    params: {
      name: 'components/Tooltips',
      path: '/components/tooltips',
    },
    defaultComponentPath: 'Vuetify/Tooltips',
    navs: true,
  },
  {
    params: {
      name: 'components/Treeview',
      path: '/components/treeview',
    },
    defaultComponentPath: 'Vuetify/Treeview',
    navs: true,
  },
  {
    params: {
      name: 'components/ItemGroups',
      path: '/components/groups/item-groups',
    },
    defaultComponentPath: 'Vuetify/Groups/ItemGroups',
    navs: true,
  },
  {
    params: {
      name: 'components/SlideGroups',
      path: '/components/groups/slide-groups',
    },
    defaultComponentPath: 'Vuetify/Groups/SlideGroups',
    navs: true,
  },
  {
    params: {
      name: 'components/Windows',
      path: '/components/groups/windows',
    },
    defaultComponentPath: 'Vuetify/Groups/Windows',
    navs: true,
  },
  {
    params: {
      name: 'components/VirtualScrollers',
      path: '/components/virtual-scrollers',
    },
    defaultComponentPath: 'Vuetify/VirtualScrollers',
    navs: true,
  },
  {
    params: {
      name: 'directives/Intersect',
      path: '/directives/Intersect',
    },
    defaultComponentPath: 'Vuetify/Directives/Intersect',
    navs: true,
  },
  {
    params: {
      name: 'directives/Mutate',
      path: '/directives/mutate',
    },
    defaultComponentPath: 'Vuetify/Directives/Mutate',
    navs: true,
  },
  {
    params: {
      name: 'directives/Resizing',
      path: '/directives/resizing',
    },
    defaultComponentPath: 'Vuetify/Directives/Resizing',
    navs: true,
  },
  {
    params: {
      name: 'directives/Ripples',
      path: '/directives/ripples',
    },
    defaultComponentPath: 'Vuetify/Directives/Ripples',
    navs: true,
  },
  {
    params: {
      name: 'directives/Scrolling',
      path: '/directives/scrolling',
    },
    defaultComponentPath: 'Vuetify/Directives/Scrolling',
    navs: true,
  },
  {
    params: {
      name: 'directives/ClickOutside',
      path: '/directives/click-outside',
    },
    defaultComponentPath: 'Vuetify/Directives/ClickOutside',
    navs: true,
  },
]
